/** Local PIN lock (PRD M01-01): PBKDF2-SHA-256 hash stored on the device; never sent anywhere. */
const enc = new TextEncoder();
const b64 = (b) => btoa(String.fromCharCode(...new Uint8Array(b)));
const unb64 = (s) => Uint8Array.from(atob(s), (c) => c.charCodeAt(0));
export async function hashPin(pin, salt, iterations = 100_000) {
    const s = salt ?? crypto.getRandomValues(new Uint8Array(16));
    const key = await crypto.subtle.importKey("raw", enc.encode(pin), "PBKDF2", false, ["deriveBits"]);
    const bits = await crypto.subtle.deriveBits({ name: "PBKDF2", hash: "SHA-256", salt: s, iterations }, key, 256);
    return { salt: b64(s.buffer), hash: b64(bits), iterations };
}
export async function verifyPin(pin, rec) {
    const again = await hashPin(pin, unb64(rec.salt), rec.iterations);
    return again.hash === rec.hash;
}
export function isValidPin(pin) {
    return /^\d{4,6}$/.test(pin) && !/^(\d)\1+$/.test(pin) && pin !== "1234" && pin !== "123456";
}
//# sourceMappingURL=pin.js.map